export const COPILOT_EVENTS = {
  NOTIFICATION_CLICKED: "copilot-notification-clicked",
  NOTIFICATION_ACKNOWLEDGED: "copilot-notification-acknowledged",
};

export const FEEDBACK_EVENTS = {
  FEEDBACK_LIKE: "copilot-feedback-like",
  FEEDBACK_DISLIKE: "copilot-feedback-dislike",
  FEEDBACK_SUBMITTED: "copilot-feedback-submitted",
  FEEDBACK_CANCELLED: "copilot-feedback-cancelled",
  CHAT_CLOSED: "copilot-chat-closed",
};
